<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    @close="handleClose"
  >
    <template
      v-if="!isEditing"
      v-slot:activator="{ on }"
    >
      <v-btn
        style="ma-2"
        depressed
        v-on="on"
      >
        <slot />
      </v-btn>
    </template>
    <v-card>
      <v-btn
        right
        absolute
        top
        icon
        @click="handleClose"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title class="headline">
        {{ isEditing?'Editing':'New' }} Project
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            id="project-name"
            v-model="project_temp.name"
            name="name"
            label="Project Name"
            :counter="255"
            :rules="projectRules.name"
            required
            @keydown.enter.prevent="create"
          />
          <v-textarea
            v-model="project_temp.description"
            label="Describe your project in a few lines"
            @keydown.enter.prevent="create"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1" />
        <v-btn
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          class="ma-2"
          depressed
          @click="create"
        >
          {{ project? 'Apply' : 'Create' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import ProjectService from './services/ProjectService'
  export default {
    props: {
      project: {},
      isEditing: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        dialog: false,
        projectRules: {
          name: [v => !!v || 'Name is required', v => (v && v.length <= 255) || 'Name must be less than 255 characters'],
        },
        project_temp: {
          name: '',
          description: '',
          is_active: true,
        },
      }
    },
    watch: {
      project (vn, vo) {
        if (vn != null) {
          this.dialog = true
          this.project_temp = this._.cloneDeep(this.project)
        }
      },
    },
    mounted () {},
    methods: {
      handleClose (e) {
        this.$refs.form.resetValidation()
        this.$refs.form.reset()
        this.dialog = false
        this.$emit('close')
      },
      handleClick (e) {
        this.dialog = true
      },
      create () {
        if (this.$refs.form.validate()) {
          ProjectService.createOrUpdate(this, this.project_temp).then(r => {
            if (r) {
              this.$emit('change')
              this.handleClose()
            }
          })
        }
      },
    },
  }
</script>
